import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {UserListComponent} from './user-list.component';

const routes: Routes = [
  {path: 'users', component: UserListComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class UserListRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-list/user-list-routing.module.ts